<template>
  <Modal modalId="downgrade-unavailable-modal" size="modal-md">
    <ModalHeader :title="$t('xUnableToDowngrade')" icon="fas fa-exclamation-triangle colorOrange">
      <div class="float-right">
        <button
          type="button"
          class="btn btn-icon-button btn-icon-button--gray"
          @click="closeDowngradeUnavailableModal()"
          data-test-hook="x-button-downgrade-unavailable-modal"
        >
          <i class="fas fa-times" />
        </button>
      </div>
    </ModalHeader>
    <ModalBody>
      <div>
        <p>{{ $t('xMustRemoveProductsToDowngrade') }}</p>
      </div>

      <div class="mt-4">
        <strong>{{ getProductName(singleGen) }}</strong>
        <p class="mt-1">{{ $t('xSingleGeneratorMaxProducts') }}</p>
      </div>

      <div class="mt-4">
        <strong>{{ getProductName(singleTank) }}</strong>
        <p class="mt-1">{{ $t('xSingleFuelMonitorMaxProducts') }}</p>
      </div>

      <div class="mt-4">
        <strong>{{ getProductName(singleHome) }}</strong>
        <p class="mt-1">{{ $t('xPremiumMonitoringMaxProducts') }}</p>
      </div>

      <div class="mt-4">
        <strong>{{ getProductName(multiHome) }}</strong>
        <p class="mt-1">{{ $t('xPremiumMultiHomeMaxProducts') }}</p>
      </div>
    </ModalBody>
    <ModalFooter>
      <button
        class="btn btn-outline-warning flex flex-grow-1"
        @click="closeDowngradeUnavailableModal()"
        data-test-hook="cancel-button-downgrade-unavailable-modal"
      >
        {{ $t('xCancel') }}
      </button>
      <button
        class="btn btn-warning flex flex-grow-1"
        @click="goToRemoveProducts()"
        data-test-hook="remove--products-button-downgrade-unavailable-modal"
      >
        {{ $t('xRemoveProductsButtonText') }}
      </button>
    </ModalFooter>
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import * as Constants from '@/constants'

export default {
  props: ['accountProfile'],
  data() {
    return {
      singleGen: null,
      singleTank: null,
      singleHome: null,
      multiHome: null
    }
  },
  methods: {
    closeDowngradeUnavailableModal() {
      this.closeModal('downgrade-unavailable-modal')
    },
    getProductName(product) {
      return product ? product.name : ''
    },
    goToRemoveProducts() {
      this.closeDowngradeUnavailableModal()
      this.$emit('mustRemoveBeforeDowngrading')
    },
    async getSubscriptionProducts() {
      await this.$store.dispatch('getAllWebSubscriptionProducts').then(response => {
        this.singleGen = response.data?.products.find(
          product => product.productId === Constants.SingleGeneratorYearlyProductId
        )
        this.singleTank = response.data?.products.find(
          product => product.productId === Constants.SingleFuelMonitorYearlyProductId
        )
        this.singleHome = response.data?.products.find(
          product => product.productId === Constants.HomePremiumOneYearlyProductId
        )
        this.multiHome = response.data?.products.find(
          product => product.productId === Constants.HomePremiumMultiHomeYearlyProductId
        )
      })
    }
  },
  async mounted() {
    await this.getSubscriptionProducts()
  }
}
</script>
